import React, { useContext, useEffect } from 'react';
import { EditGameCategoryContext, IEditGameCategoryContext } from '../../editGameCategoryState/editGameCategoryContext';
import WithAdditionalValidationState from 'components/WithAdditionalValidation/WithAdditionalValidationState';
import CreationForm from './components/EditForm/EditForm';
import TranslationsForm from './components/TranslationsForm';
import style from './Forms.module.scss';

const Forms: React.FC = () => {
	const { visibleForm } = useContext<IEditGameCategoryContext>(EditGameCategoryContext);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [visibleForm]);

	return (
		<div className={style.container} data-test="Forms">
			<WithAdditionalValidationState>
				<CreationForm isVisible={visibleForm === 'mainForm'} />
				<TranslationsForm isVisible={visibleForm === 'translations'} />
			</WithAdditionalValidationState>
		</div>
	);
};

export default Forms;
